import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import axios from 'axios';

@Component({
  selector: 'app-printfertilizer',
  templateUrl: './printfertilizer.component.html',
  styleUrls: ['./printfertilizer.component.css']
})
export class PrintfertilizerComponent implements OnInit, OnDestroy {

  @ViewChild('onstock', { static: false }) onstock: any;
  @ViewChild('inzone', { static: false }) inzone: any;
  @ViewChild('outzone', { static: false }) outzone: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  zone: any;
  usercode: any;
  constructor(private spinner: NgxSpinnerService, private auth: Authenticationservice, private route: ActivatedRoute, private router: Router) {
    let userdata: any;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.usercode = userdata.supcode;
  }

  year_id = '';
  ngOnInit(): void {
    this.year_id = this.route.snapshot.paramMap.get('year');
    let d1 = new Date(), d2 = new Date();
    d1.setDate(d1.getDate() - 14);
    this.inDate1 = d1;
    this.inDate2 = d2;
    //console.log(`Time elapsed d:`, d);
    console.log(`Time inDate1:`, this.inDate1);
    console.log(`Time inDate2:`, this.inDate2);

    setTimeout(() => {
      this.Loaddata_api()
    }, 200);
  }
  ngOnDestroy(): void {
  }

  Loaddata_api() {
    /*let date1 = this.date2Local(this.inDate1);
    let date2 = this.date2Local(this.inDate2);
    console.log('date1', date1, 'date2', date2)
    */
    /*if (this.newtable1 != undefined || this.newtable1 != null) {
      this.newtable1.destroy();
      this.newtable2.destroy();
      this.newtable3.destroy();
    }*/

    setTimeout(() => {
      this.Loaddatabystock();
      this.Loaddatabyzone();
      this.Loaddataoutzone();
    }, 100);
  }

  //inDate:Array<Date>=[,]
  inDate1: Date
  inDate2: Date

  date2Local(date_i: Date) {
    if (!date_i) { return ''; }
    let objDate = new Date(date_i);
    //let objDate = date;
    let day = (objDate.getDate()).toString();
    let month = (objDate.getMonth() + 1).toString();
    let year = (objDate.getFullYear()).toString();
    return year + "-" + month + "-" + day;
  }
  id = 1;
  chagetab(id: number) {
    this.id = id;
    if (id == 1) { }
    else if (id == 2) { }
    else if (id == 3) { }
  }

  // ข้อมูลสต็อคโรงงาน
  databystock = [];
  newtable1: any;
  Loaddatabystock() {
    let date1 = this.date2Local(this.inDate1)
    let date2 = this.date2Local(this.inDate2)
    if (this.newtable1 != undefined || this.newtable1 != null) this.newtable1.destroy();;

    //  let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfactor6566w?supzone=%27"+this.zone+"%27&stockid=%2700%27"
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfactor]&w=[YearID]='" + this.year_id + "'and cast(datepost as date) between '" + date1 + "'and'" + date2 + "' and[supzone]=%27" + this.zone + "%27and[stockid]=%2700%27"
    this.spinner.show();
    axios.get(url).then(res => {//onstock
      let resdata = res.data
      //resdata.sort(function(a, b){return b.docid - a.docid});
      this.databystock = (resdata);
      setTimeout(() => {
        this.newtable1 = $(this.onstock.nativeElement).DataTable({ order: [[1, 'desc']] });
      }, 300);
      this.spinner.hide();
    }).catch(err => { throw (err) })
  }

  // ค้นหาข้อมูลสต็อคโรงงาน
  /*Filterby(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.databystock.filter = filterValue.trim().toLowerCase();;
    if (this.databystock.paginator) {
      this.databystock.paginator.firstPage();
    }
  }*/

  // ข้อมูลเบิกปัจจัยในโซน
  databyzone = [];
  newtable2: any;
  Loaddatabyzone() {
    let date1 = this.date2Local(this.inDate1)
    let date2 = this.date2Local(this.inDate2)
    if (this.newtable2 != undefined || this.newtable2 != null) this.newtable2.destroy();

    this.spinner.show();
    //let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfactor6566w?stockid=%27"+this.zone+"%27"
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfactor]&w=[YearID]='" + this.year_id + "'and cast(datepost as date) between '" + date1 + "'and'" + date2 + "'and[stockid]=%27" + this.zone + "%27"
    axios.get(url).then(res => {
      let resdata = res.data
      //resdata.sort(function(a, b){return b.docid - a.docid});
      this.databyzone = (resdata);
      setTimeout(() => {
        this.newtable2 = $(this.inzone.nativeElement).DataTable({ order: [[1, 'desc']] });
      }, 300);
      this.spinner.hide();
    }).catch(err => { throw (err) })
  }

  // ข้อมูลในเบิกปัจจัยนอกโซน
  dataoutzone = [];
  newtable3: any;
  Loaddataoutzone() {
    let date1 = this.date2Local(this.inDate1)
    let date2 = this.date2Local(this.inDate2)
    if (this.newtable3 != undefined || this.newtable3 != null) this.newtable3.destroy();

    this.spinner.show();
    // let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfactor6566w?supzonefm=%27"+this.zone+"%27&ck_outzone=1"
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfactor]&w=[YearID]='" + this.year_id + "'and cast(datepost as date) between '" + date1 + "'and'" + date2 + "'and[supzonefm]=%27" + this.zone + "%27 and ck_outzone=1"
    axios.get(url).then(res => {
      let resdata = res.data
      //resdata.sort(function(a, b){return b.docid - a.docid});
      this.dataoutzone = (resdata);
      setTimeout(() => {
        this.newtable3 = $(this.outzone.nativeElement).DataTable({ order: [[0, 'desc']] });
      }, 300);
      this.spinner.hide();
    }).catch(err => { throw (err) })
  }

  cancledata(data: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?[firebaseid]=" + data.firebaseid + "&doc_status='X'";
    //console.log('cancledata_url:', url,)
    if (confirm("ต้องการยกเลิกรายการ " + data.docid + " นี้ใช่หรือไม่")) {
      //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_doc_status?docid=" + docid + "&doc_status=X";
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("ยกเลิกเรียบร้อยแล้วค่ะ ^^");
        }
        else if (res.data.code) {
          alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
        }
        else {
          alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
        }
      }).catch(err => { throw (err) })
      this.Loaddatabystock();
    }
    else { }
  }

  // ยืนยันเบิกแล้ว
  confirmused(data: any) {
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_doc_print?doc_print=1&docid=" + docid;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?[firebaseid]=" + data.firebaseid + "&doc_print='1'";
    if (confirm("ยืนยันการเบิก") == true) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("ยืนยันเรียบร้อยแล้วค่ะ ^^");
          this.Loaddatabystock();
        }
        else {
          alert("ยืนยันไม่สำเร็จกรุณาลองใหม่ !!!");
        }
      }).catch(err => { throw (err) })
    }
    else {
      //console.log("cancle");
    }

  }
  //year :string='6566';

  // ออกใบพิมพ์
  printdoc(year, fmcode, docid) {
    this.router.navigateByUrl("/docfertilizer", { state: { year: year, data: fmcode, doc_id: docid } });
  }
  // ออกใบพิมพ์ซ้ำ 1 รายการ
  reprintdoc(year, fmcode, docid) {
    this.router.navigateByUrl("/docfertilizer", { state: { year: year, data: fmcode, doc_id: docid, status: '1' } });
  }
}
